import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, shareReplay, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResearchDataApiService {
  readonly BASE_HREF = '/api/v1.0/research-data';
  /* the research backend is slow: each csv is fetched once per instance - provide the service on a
     component to scope the cache to that component's lifetime */
  private cache = new Map<string, Observable<string>>();
  constructor(
    private http: HttpClient,
    private translocoService: TranslocoService
  ) {}

  getDataFromFullUrl(fullPath: string, label = ''): Observable<string> {
    /* we need to add /api so interceptor will trigger*/
    const url = new URL(fullPath);
    const apiLink = `/api${url.pathname}${url.search}`;
    const language = this.translocoService.getActiveLang();
    const key = JSON.stringify([apiLink, label.toString(), language]);
    if (!this.cache.has(key)) {
      let queryParams = new HttpParams();
      queryParams = queryParams.append('label', label.toString());
      queryParams = queryParams.append('language', language);
      const request$ = this.http.get(apiLink, { responseType: 'text', params: queryParams }).pipe(
        /* a failed request is not cached, so the next toggle retries it */
        tap({ error: () => this.cache.delete(key) }),
        shareReplay(1)
      );
      this.cache.set(key, request$);
    }
    return this.cache.get(key);
  }
}
